import React from 'react';
import { Users, BookOpen, Gift, Star } from 'lucide-react';
export function SocialProofBar() {
  return <div className="bg-brand-card text-white py-3 md:py-4 px-3 border-y border-brand-accent/30" data-id="element-278">
      <div className="max-w-3xl mx-auto grid grid-cols-4 gap-2 md:gap-4" data-id="element-279">
        <div className="flex flex-col items-center text-center" data-id="element-280">
          <Users className="w-4 h-4 md:w-6 md:h-6 mb-1 text-brand-accent" data-id="element-281" />
          <span className="text-sm md:text-lg font-black text-white" data-id="element-282">+300</span>
          <span className="text-[9px] md:text-xs text-gray-400 font-medium" data-id="element-283">
            docentes confían
          </span>
        </div>
        <div className="flex flex-col items-center text-center" data-id="element-284">
          <BookOpen className="w-4 h-4 md:w-6 md:h-6 mb-1 text-brand-accent" data-id="element-285" />
          <span className="text-sm md:text-lg font-black text-white" data-id="element-286">
            6 Tomos
          </span>
          <span className="text-[9px] md:text-xs text-gray-400 font-medium" data-id="element-287">
            listos para usar
          </span>
        </div>
        <div className="flex flex-col items-center text-center" data-id="element-288">
          <Gift className="w-4 h-4 md:w-6 md:h-6 mb-1 text-brand-accent" data-id="element-289" />
          <span className="text-sm md:text-lg font-black text-white" data-id="element-290">
            4 Bonos
          </span>
          <span className="text-[9px] md:text-xs text-gray-400 font-medium" data-id="element-291">
            incluidos gratis
          </span>
        </div>
        <div className="flex flex-col items-center text-center" data-id="element-292">
          <div className="flex mb-1" data-id="element-293">
            {[...Array(5)].map((_, i) => <Star key={i} className="w-3 h-3 md:w-4 md:h-4 text-brand-accent fill-current" data-id="element-294" />)}
          </div>
          <span className="text-sm md:text-lg font-black text-white" data-id="element-295">
            4.9/5
          </span>
          <span className="text-[9px] md:text-xs text-gray-400 font-medium" data-id="element-296">
            valoración
          </span>
        </div>
      </div>
    </div>;
}